import { Box, CircularProgress, Typography } from '@mui/material'
import MoreVertIcon from '@mui/icons-material/MoreVert'
import IconDropdown from 'components/IconDropdown/IconDropdown'
import { useTranslation } from 'react-i18next'
import theme from 'lib/theme'
import { ToolbarArea, ToolbarContent, ToolbarSaveBtn } from './Toolbar.styled'

type ToolbarProps = {
  listOptions: { label: string; value: string }[]
  handleOpenModal: (selectedValue: string, innerValue: string) => void
  isLoadingPostRequest: boolean
  handleClick?: () => void
  saveBtnEnabled: boolean
  saveBtnVisible: boolean
  toolbarText: string
}

export const Toolbar = ({
  listOptions,
  isLoadingPostRequest,
  handleOpenModal,
  handleClick,
  saveBtnEnabled,
  saveBtnVisible,
  toolbarText,
}: ToolbarProps) => {
  const { t } = useTranslation()

  return (
    <Box sx={{ flexGrow: 3 }}>
      <ToolbarArea>
        <ToolbarContent>
          <Typography sx={{ fontWeight: 'bold' }}>{toolbarText}</Typography>
          <Box display='flex'>
            {saveBtnVisible && handleClick && (
              <ToolbarSaveBtn
                onClick={async () => handleClick()}
                type='submit'
                disabled={!saveBtnEnabled}>
                {isLoadingPostRequest ? (
                  <CircularProgress
                    size='20px'
                    sx={{
                      color: theme.palette.commonColors.white,
                    }}
                  />
                ) : (
                  t('serviceArea.saveCoordinates')
                )}
              </ToolbarSaveBtn>
            )}
            <IconDropdown
              anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
              transformOrigin={{ vertical: 'top', horizontal: 'right' }}
              minWidth='160px'
              Icon={MoreVertIcon}
              isIconOnly
              options={listOptions}
              ariaLabel={t('serviceAreaSettings')}
              onChange={handleOpenModal}
            />
          </Box>
        </ToolbarContent>
      </ToolbarArea>
    </Box>
  )
}
